// app/javascript/controllers/clipboard_controller.js
import { Controller } from "@hotwired/stimulus"

// Контроллер для копирования текста в буфер обмена.
//
// HTML-структура:
// <div data-controller="clipboard" data-clipboard-success-text-value="Скопировано!">
//   <pre data-clipboard-target="source">Текст для копирования</pre>
//   <button data-action="click->clipboard#copy">Копировать</button>
// </div>
//
export default class extends Controller {
  static targets = ["source"]
  static values = {
    successText: String // Текст, который будет показан на кнопке после копирования
  }

  copy(event) {
    // Убедимся, что у нас есть что копировать
    if (!this.hasSourceTarget) {
      console.error("Clipboard controller needs a `source` target.");
      return;
    }

    const textToCopy = this.sourceTarget.textContent;
    const button = event.currentTarget;
    const originalButtonText = button.innerHTML;

    navigator.clipboard.writeText(textToCopy).then(() => {
      // Успех! Меняем текст кнопки на сообщение об успехе.
      button.innerHTML = this.successTextValue || 'Copied!';
      button.disabled = true;

      // Возвращаем оригинальный текст через 2 секунды
      setTimeout(() => {
        button.innerHTML = originalButtonText;
        button.disabled = false;
      }, 2000);
    }).catch(err => {
      // Обработка ошибки, если браузер не поддерживает API или запретил доступ
      console.error('Failed to copy text: ', err);
      // Можно временно показать сообщение об ошибке на кнопке
      button.innerHTML = 'Ошибка';
      setTimeout(() => {
        button.innerHTML = originalButtonText;
      }, 2000);
    });
  }
}